module.exports = __webpack_public_path__ + "static/media/pozadinaHD.d407ca97.png";